export default {
  首页: "Hjem",
  资产: "Aktiva",
  币币: "Spot",
  快捷买币: "Kjøp krypto raskt",
  "支持多种方式购买，购买更简单": "Enkelt kjøp med flere betalingsmetoder",
  语言设置: "Språkinnstillinger",
  确认恢复: "Bekreft gjenoppretting",
  "输入邮箱，方便我们联系您":
    "Skriv inn e-postadressen din slik at vi kan kontakte deg",
  划转: "Overfør",
  行情: "Marked",
  "24H成交": "24h volum",
  累计收益: "Total avkastning",
  充值时间: "Innskuddsdato",
  到期时间: "Utløpsdato",
  数量: "Mengde",
  操作: "Handling",
  资产信息: "Aktivainformasjon",
  复制地址: "Kopier adresse",
  链名称: "Kjedenavn",
  充值地址: "Innskuddsadresse",
  收款地址: "Mottakeradresse",
  账单: "Faktura",
  提现金额: "Uttaksbeløp",
  接收地址: "Mottakeradresse",
  交易密码: "Handelspassord",
  提现全部: "Ta ut alt",
  保存图片: "Lagre bilde",
  输入您的交易密码: "Skriv inn handelspassordet ditt",
  确定: "Bekreft",
  地址: "Adresse",
  注册时间: "Registreringsdato",
  取消: "Avbryt",
  是否划转: "Overfør?",
  登录: "Logg inn",
  我的地址: "Mine adresser",
  登录密码和交易密码: "Innloggingspassord og handelspassord",
  注册: "Registrer",
  密码: "Passord",
  设置密码: "Sett passord",
  重复密码: "Gjenta passord",
  新密码: "Nytt passord",
  确认新密码: "Bekreft nytt passord",
  充值: "Sett inn",
  充值货币: "Sett inn valuta",
  合约账户充值: "Sett inn på futureskonto",
  账户充值: "Sett inn på konto",
  其他: "Annet",
  我的邀请码: "Min invitasjonskode",
  提现: "Ta ut",
  客服: "Kundeservice",
  持有详情: "Detaljer om beholdning",
  请输入内容: "Skriv inn innhold",
  邀请好友来领取奖励: "Inviter venner og motta belønninger",
  复制链接: "Kopier lenke",
  重复设置新的密码: "Gjenta nytt passord",
  保存: "Lagre",
  我的: "Min konto",
  "邮箱/手机号": "E-post/mobilnummer",
  备注: "Merknad",
  地址管理: "Adresseadministrasjon",
  我的团队: "Mitt team",
  联系我们: "Kontakt oss",
  竭诚为您服务: "Vi står til tjeneste",
  提取收益: "Ta ut avkastning",
  带给我的收益: "Generert avkastning",
  添加: "Legg til",
  名称: "Navn",
  添加地址: "Legg til adresse",
  修改地址: "Endre adresse",
  可提现: "Uttakbart",
  安全中心: "Sikkerhetssenter",
  收益划转: "Overfør avkastning",
  通知中心: "Varsler",
  "累计收益:": "Total avkastning:",
  注册用户: "Registrerte brukere",
  奖励规则: "Belønningsregler",
  帮助反馈: "Hjelp og tilbakemelding",
  邀请好友: "Inviter venner",
  恢复身份: "Gjenopprett identitet",
  选择语言: "Velg språk",
  设置新的密码: "Sett nytt passord",
  暂无活动: "Ingen aktive aktiviteter",
  "月增长量(+)": "Månedlig vekst (+)",
  可提取: "Uttakbart",
  反馈类型: "Tilbakemeldingstype",
  赠送: "Gave",
  已经复制: "Kopiert",
  保存成功: "Lagret",
  划转成功: "Overføring vellykket",
  过期: "Utløpt",
  提交成功: "Innsending vellykket",
  "服务器繁忙，稍后在试": "Serveren er opptatt, prøv igjen senere",
  全部: "Alle",
  一级: "Nivå 1",
  二级: "Nivå 2",
  三级: "Nivå 3",
  级: "Nivå",
  删除成功: "Slettet",
  选择地址: "Velg adresse",
  不再提醒: "Ikke vis igjen",
  "最小充值金额：": "Minimum innskuddsbeløp:",
  选择币种: "Velg kryptovaluta",
  输入投资金额: "Skriv inn investeringsbeløp",
  输入账户密码: "Skriv inn kontopassord",
  投资: "Invester",
  订单编号: "Ordrenummer",
  投资周期: "Investeringsperiode",
  投资资金: "Investert beløp",
  投资时间: "Investeringstidspunkt",
  状态: "Status",
  投资中: "Aktiv",
  已到期: "Utløpt",
  暂无数据: "Ingen data",
  转入: "Overfør til",
  邮箱: "E-post",
  请输入邮箱: "Skriv inn e-postadresse",
  请输入格式正确的邮箱: "Skriv inn en gyldig e-postadresse",
  请输入验证码: "Skriv inn bekreftelseskode",
  获取验证码: "Få bekreftelseskode",
  请输入邀请码: "Skriv inn invitasjonskode",
  今天: "I dag",
  昨天: "I går",
  最近七天: "Siste 7 dager",
  邀请: "Inviter",
  购买数量: "Kjøpsmengde",
  产品详情: "Produktdetaljer",
  币种: "Kryptovaluta",
  利息币种: "Avkastningsvaluta",
  理财类型: "Type finansprodukt",
  产品费率: "Produktgebyrer",
  进行中: "Aktiv",
  每天: "Daglig",
  请输入搜索关键词: "Skriv inn søkeord",
  通知: "Varsler",
  查看更多: "Se mer",
  理财宝: "Finansprodukter",
  周期: "Løpetid",
  年利率: "Årlig rente (APY)",
  更多产品: "Flere produkter",
  灵活存取: "Fleksibel sparing",
  稳定收益: "Stabil avkastning",
  合约指南: "Futures-guide",
  资金划转出: "Utgående overføring",
  矿池收益: "Gruvebelønning",
  提现手续费: "Uttaksgebyr",
  冻结资金: "Frosne midler",
  解冻资金: "Frigi frosne midler",
  闪兑支出: "Kostnad for rask veksling",
  闪兑收入: "Inntekt fra rask veksling",
  闪兑手续费: "Gebyr for rask veksling",
  合约支出: "Futures-kostnad",
  合约收入: "Futures-inntekt",
  输入的金额不可大于可用金额: "Beløpet kan ikke overstige tilgjengelig beløp",
  全部兑换成功: "Fullført veksling",
  返回: "Tilbake",
  查看历史: "Se historikk",
  闪兑历史: "Historikk for rask veksling",
  支付: "Betal",
  获取: "Få",
  时间: "Tid",
  手续费: "Transaksjonsgebyr",
  折扣: "Rabatt",
  价格: "Pris",
  逐仓: "Isolert margin",
  全仓: "Kryssmargin",
  市价委托: "Markedsordre",
  限价委托: "Limitordre",
  请输入本金: "Skriv inn hovedstol",
  请输入价格: "Skriv inn pris",
  "可做空/做多": "Mulig å shorte/longe",
  设置止盈止损: "Sett take-profit/stop-loss",
  止盈价: "Take-profit pris",
  止损价: "Stop-loss pris",
  成本: "Kostpris",
  做多: "Long",
  做空: "Short",
  仓位信息: "Posisjonsinformasjon",
  一键平仓: "Lukk posisjon (ett klikk)",
  永续: "Perpetual",
  浮动盈亏: "Urealisert gevinst/tap",
  平仓: "Lukk posisjon",
  反向开仓: "Åpne omvendt posisjon",
  一键撤销: "Avbryt alle (ett klikk)",
  倍杠杆: "x giring",
  执行价格: "Utførelsespris",
  委托数量: "Ordremengde",
  保证金: "Margin",
  成交价: "Utførelsespris",
  创建时间: "Opprettelsestid",
  撤销: "Avbryt",
  合约市场: "Futures-marked",
  交易方向: "Handelsretning",
  委托价格: "Ordrepris",
  委托金额: "Ordrebeløp",
  资金费率: "Finansieringsrente",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodisk gebyr betalt av long- og short-posisjoner, avregnes hver 8. time.",
  "资金费率为正，多方向空方支付资金费用。":
    "Med positiv finansieringsrente betaler long-posisjoner til short-posisjoner.",
  "资金费率为负，空方向多方支付资金费用。":
    "Med negativ finansieringsrente betaler short-posisjoner til long-posisjoner.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Er du sikker på at du vil åpne en omvendt posisjon? Dette vil kjøpe motsatt retning av din nåværende posisjon.",
  "仓位止盈/止损": "Take-profit/Stop-loss for posisjon",
  合约名称: "Futures-kontrakt",
  开仓价格: "Åpningspris",
  指数价格: "Indekspris",
  止盈设置: "Take-profit-innstillinger",
  请输入止盈价: "Skriv inn take-profit-pris",
  "当指数价格触达*时，将会触发委托平仓":
    "Når indeksprisen når *, vil en lukkingsordre utløses.",
  预计盈亏: "Forventet gevinst/tap",
  当前仓位: "Nåværende posisjon",
  平仓金额: "Lukkingsbeløp",
  仓位模式: "Posisjonsmodus",
  全仓模式: "Kryssmargin-modus",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "I kryssmargin-modus brukes alle tilgjengelige midler på futureskontoen din som margin. Likvidasjon skjer når tapet overstiger din totale saldo, noe som resulterer i tap av hele marginen og posisjonen din.",
  逐仓模式: "Isolert margin-modus",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "En bestemt mengde margin tildeles en posisjon. Hvis margintapet faller under vedlikeholdsmarginnivået, blir posisjonen likvidert. Du kan øke eller redusere marginen for denne posisjonen.",
  "是否撤销？": "Avbryt ordre?",
  "是否一键撤销？": "Avbryt alle ordre?",
  "是否一键平仓？": "Lukk alle posisjoner?",
  持仓保证金: "Margin for nåværende posisjon",
  风险率: "Risikoprosent",
  未实现盈亏: "Urealisert gevinst/tap",
  可用保证金: "Tilgjengelig margin",
  净值: "Nettoverdi",
  账户余额: "Kontosaldo",
  合约计算器: "Futures-kalkulator",
  交易记录: "Transaksjonshistorikk",
  "*倍杠杆": "*x giring",
  "平仓盈亏：": "Lukket gevinst/tap:",
  时间筛选: "Tidsfilter",
  仓位类型: "Posisjonstype",
  订单状态: "Ordrestatus",
  订单类型: "Ordretype",
  平仓价格: "Lukkingspris",
  持仓数量: "Posisjonsmengde",
  "手续费(%)": "Transaksjonsgebyr (%)",
  平仓时间: "Lukkingstid",
  平仓类型: "Lukkingstype",
  手动平仓: "Manuell lukking",
  强制平仓: "Tvungen likvidasjon",
  近1天: "Siste dag",
  近7天: "Siste 7 dager",
  近30天: "Siste 30 dager",
  近180天: "Siste 180 dager",
  持仓: "Åpen posisjon",
  已取消: "Kansellert",
  分时: "Intradag",
  "24H额(USDT)": "24h volum (USDT)",
  "24H低": "24h lav",
  "24H量(BTC)": "24h volum (BTC)",
  "24H高": "24h høy",
  "10秒": "10 sekunder",
  "30秒": "30 sekunder",
  "1分": "1 minutt",
  "3分": "3 minutter",
  "5分": "5 minutter",
  "30分": "30 minutter",
  "1小时": "1 time",
  "4小时": "4 timer",
  "8小时": "8 timer",
  "1天": "1 dag",
  "1周": "1 uke",
  "1月": "1 måned",
  单向持仓: "Ensrettet posisjon",
  杠杆: "Giring",
  仓位: "Posisjon",
  计算结果: "Resultat",
  盈亏: "Gevinst/Tap",
  收益率: "Avkastning",
  计算结果仅供参考: "Resultatet er veiledende",
  成交后仓位大小: "Posisjonsstørrelse etter utførelse",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Resultatet er veiledende, faktiske resultater kan variere på grunn av gebyrer.",
  目标价格: "Målpris",
  开始计算: "Beregn",
  强平价格: "Likvideringspris",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Kontroller kjedenavnet nøye før innskudd. Feil innskudd kan ikke reverseres. Minimumsinnskuddsbeløpet er *. Innskudd under dette beløpet vil ikke bli behandlet. Ikke send andre eiendeler til denne adressen. Ikke bruk ICO- eller crowdfunding-adresser for uttak.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minimum uttaksmengde er *. Uttaksgebyrer vil bli trukket fra uttaksbeløpet. Kontroller mottakeradressen nøye. Ikke send * til adresser utenfor *. Ikke bruk ICO- eller crowdfunding-adresser.",
  退出登录: "Logg ut",
  加仓: "Øk posisjon",
  新增仓位: "Ny posisjon",
  输入加仓金额: "Skriv inn beløp for å øke posisjonen",
  "当前可用:": "Nå tilgjengelig:",
  资产账单: "Aktivafaktura",
  保存二维码: "Lagre QR-kode",
  温馨提示: "Merknad",
  "请注意：您当前使用的网络": "Merk: Du bruker for øyeblikket nettverket",
  输入提现地址: "Skriv inn uttaksadresse",
  "可用金额：": "Tilgjengelig beløp:",
  输入资产密码: "Skriv inn aktivapassord",
  可用手续费: "Tilgjengelig gebyr",
  "折扣%": "Rabatt %",
  实扣手续费: "Faktisk belastet gebyr",
  实际到账: "Faktisk mottatt beløp",
  未设置资产密码: "Aktivapassord ikke satt",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "For din sikkerhet, sett et aktivapassord før du tar ut.",
  热榜: "Populært",
  涨幅榜: "Største økninger",
  跌幅榜: "Største fall",
  成交额榜: "Volumrangering",
  关于我们: "Om oss",
  登录密码: "Innloggingspassord",
  设置: "Innstillinger",
  资产密码: "Aktivapassord",
  修改登录密码: "Endre innloggingspassord",
  原密码: "Gammelt passord",
  请输入新密码: "Skriv inn nytt passord",
  请输入原密码: "Skriv inn gammelt passord",
  确认密码: "Bekreft passord",
  确定修改: "Bekreft endring",
  修改资产密码: "Endre aktivapassord",
  验证码: "Bekreftelseskode",
  资产密码使用提示: "Tips for aktivapassord",
  "资产密码用于转移、提取资产和交易。":
    "Aktivapassord brukes til å overføre, ta ut og handle eiendeler.",
  "创建与登录密码不同的资产密码。":
    "Lag et aktivapassord som er forskjellig fra innloggingspassordet.",
  "定期更改您的资产密码。": "Endre aktivapassordet ditt regelmessig.",
  提币历史: "Uttakshistorikk",
  "金额/余额": "Beløp/Saldo",
  "手续费/折扣": "Gebyr/Rabatt",
  自选: "Favoritter",
  现货: "Spot",
  市价: "Markedspris",
  止损设置: "Stop-loss-innstillinger",
  合约K线图: "Futures-diagram",
  "24H量": "24h volum",
  "24H额": "24h volum (USDT)",
  合作指南: "Partnerguide",
  盈亏计算: "Beregning av gevinst/tap",
  当前可用: "Nå tilgjengelig",
  请输入加仓金额: "Skriv inn beløp for å øke posisjonen",
  请重新输入加仓金额: "Skriv inn beløpet for å øke posisjonen på nytt",
  平仓数量: "Mengde å lukke",
  欢迎登录: "Velkommen tilbake",
  "忘记密码?": "Glemt passord?",
  "还没有账号？": "Har du ikke konto?",
  立即注册: "Registrer deg nå",
  繁體中文: "Tradisjonell kinesisk",
  找回密码: "Gjenopprett passord",
  下一步: "Neste",
  注册账户: "Registrer konto",
  "请输入邀请码(选填)": "Skriv inn invitasjonskode (valgfritt)",
  谢邀豪礼: "Invitasjonsbonus",
  "24小时邀请好友排名": "24-timers invitasjonsrangering",
  "*人": "* personer",
  "差*人": "Mangler * personer",
  "已超过10万人，每月轻松赚钱":
    "Over 100 000 brukere, tjen penger enkelt hver måned",
  最高: "Maksimum",
  邀请链接: "Invitasjonslenke",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Del i transaksjonsgebyrene generert av vennene dine (spot, futures, margin, rask veksling).",
  平台和您一起分享手续费: "Del transaksjonsgebyrene med plattformen",
  "*级": "* nivå",
  规则: "Regler",
  我的好友: "Mine venner",
  好友详情: "Venndetaljer",
  获得好友佣金方案: "Vennerprovisjonsplan",
  我的等级: "Mitt nivå",
  我的邀请数据: "Mine invitasjonsstatistikker",
  当前等级: "Nåværende nivå",
  平台奖励您: "Plattformbelønning til deg",
  最高可获取平台奖励: "Maksimal plattformbelønning",
  邀请规则: "Invitasjonsregler",
  "邀请*级有效好友": "Inviter aktive venner på nivå *",
  好友等级: "Vennivå",
  人: "personer",
  奖金派送: "Bonusutbetaling",
  平台奖励: "Plattformbelønning",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Plattformen har rett til endelig tolkning. Ved svindelaktiviteter vil belønninger bli trukket fra og kontoen din frosset. Tapte eiendeler kan ikke gjenopprettes.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Kontoen din må være aktiv, definert som et innskudd av minst * USDT i verdi i en hvilken som helst kryptovaluta.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Den inviterte vennen din må være en aktiv nedlinje, definert som et innskudd av minst * USDT i verdi.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Invitatør og invitert kan ikke dele samme IP-adresse.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-nivå bestemmes av antall inviterte venner på nivå *.",
  佣金成分: "Provisjonskomponenter",
  收益统计: "Avkastningsstatistikk",
  昨日收益: "Gårsdagens avkastning",
  月收益: "Månedlig avkastning",
  获取收益: "Få avkastning",
  "总收益：": "Total avkastning:",
  "*级好友": "Venner på nivå *",
  理财购买: "Kjøp finansprodukt",
  期限: "Løpetid",
  可用金额: "Tilgjengelig beløp",
  预估收益: "Estimert avkastning",
  申购上限: "Maksimalt kjøp",
  项目剩余: "Gjenstående prosjekt",
  "买入后预计*(SGT)开始计算收益。":
    "Avkastning forventes å begynne å løpe rundt *(SGT) etter kjøp.",
  计息日: "Rentestartdato",
  申购日: "Kjøpsdato",
  到账日: "Krediteringsdato",
  到期自动续投: "Automatisk reinvestering ved forfall",
  申购: "Kjøp",
  搜索理财项目: "Søk etter finansprodukt",
  超高年化随心选: "Velg blant produkter med høy avkastning",
  "自由选择理财币种，稳定超额收益":
    "Velg fritt din kryptovaluta for stabil, over gjennomsnittet avkastning",
  理财总资产: "Totalt investerte eiendeler",
  申购数量: "Mengde å kjøpe",
  立即购买: "Kjøp nå",
  年化收益率: "Årlig prosentvis avkastning (APY)",
  理财订单: "Finansproduktordrer",
  持有: "I besittelse",
  申购份额: "Kjøpt andel",
  到账日期: "Krediteringsdato",
  申购成功: "Kjøp vellykket",
  到期: "Utløpt",
  是否选择做多: "Åpne long-posisjon?",
  "可用余额为0 不能操作": "Saldoen er 0, handling ikke mulig",
  福利中心: "Bonussenter",
  奖励记录: "Belønningshistorikk",
  我获取到的奖励: "Mine opptjente belønninger",
  总价值: "Total verdi",
  新手任务: "Oppgaver for nye brukere",
  身份认证: "Identitetsverifisering (KYC)",
  身份验证: "Identitetsverifisering",
  去验证: "Verifiser nå",
  审核中: "Under behandling",
  已验证: "Verifisert",
  认证失败: "Verifisering mislyktes",
  基础认证: "Grunnleggende verifisering",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Merk: Verifisert informasjon kan ikke endres. Skriv inn nøyaktige data.",
  "国家/地区": "Land/Region",
  请选择: "Velg",
  证件类型: "Dokumenttype",
  证件编码: "Dokumentnummer",
  身份证: "Nasjonalt ID-kort",
  护照: "Pass",
  驾驶证: "Førerkort",
  请输入编码: "Skriv inn nummer",
  名字: "Fornavn",
  请输入: "Skriv inn",
  中间名: "Mellomnavn",
  选填: "Valgfritt",
  姓氏: "Etternavn",
  中国: "Kina",
  身份上传: "Last opp identitetsdokument",
  上传身份证: "Last opp nasjonalt ID-kort",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Last opp i JPG/JPEG/PNG-format. Sørg for at bildene er klare, komplette og jevnt opplyst. Maksimalt *MB.",
  确定提交: "Send inn",
  去认证: "Verifiser",
  挑战任务: "Utfordringsoppgaver",
  注册认证任务: "Registrerings- og verifiseringsoppgave",
  完成注册认证即可领取: "Fullfør registrering og verifisering for å motta",
  领取奖励: "Motta belønning",
  新人豪礼: "Velkomstbonus",
  "参与人数：": "Antall deltakere:",
  条件: "Betingelse",
  入金量: "Innskuddsbeløp",
  完成: "Fullført",
  任务奖励: "Oppgavebelønning",
  距任务更新: "Til oppgaveoppdatering",
  "条件：": "Betingelse:",
  活动规则: "Aktivitetsregler",
  奖励明细: "Belønningsdetaljer",
  已获得: "Opptjent",
  交易奖励: "Handelsbelønning",
  Win奖励: "WIN-belønning",
  已领取: "Mottatt",
  亏损金额超过: "Tapsbeløp overstiger",
  单笔开仓金额超过: "Enkelt ordrebeløp overstiger",
  交易量: "Handelsvolum",
  待完成: "Ventende",
  入金: "Innskudd",
  盈利金额超过: "Gevinstbeløp overstiger",
  开仓金额: "Ordrebeløp",
  开仓金: "Ordrebeløp",
  盈利: "Gevinst",
  亏损: "Tap",
  领取: "Motta",
  未领取: "Ikke mottatt",
  待领取: "Venter på mottak",
  再交易: "Handel videre",
  即可获得: "for å motta",
  领取成功: "Mottatt",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Alle aktiviteter vil bli avregnet på sluttdatoen. Belønninger utløper etter dette.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Opptjent avkastning vil bli kreditert din bonus-konto, som du kan veksle eller ta ut når som helst.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Belønningskryptovalutaen avhenger av oppgaven.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Plattformen har rett til endelig tolkning. Ved juks med oppgaver vil belønninger bli tilbakeholdt og kontoen din kan fryses.",
  成长学院: "Akademi",
  "区块链 & 加密货币": "Blockchain & Kryptovaluta",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Din komplette guide til kryptovaluta. Vi følger deg på din kryptoreise.",
  "全仓合约定单的全部保证金。": "Total margin for kryssmargin futures-ordrer.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (urealisert gevinst/tap - gebyrer - finansieringsrenter) = Nettoverdi / Brukt margin * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Urealisert gevinst/tap påvirker direkte 'tilgjengelig margin'. Hvis urealisert gevinst/tap øker, øker tilgjengelig margin og omvendt.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Brukt margin) + (urealisert gevinst/tap - gebyrer - finansieringsrenter)",
  "注:可继续用于开仓的保证金。":
    "Merk: Margin som er tilgjengelig for å åpne nye posisjoner.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (urealisert gevinst/tap - gebyrer - finansieringsrenter)",
  "注:当前的资金结余。": "Merk: Gjeldende saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Refererer til total saldo på futureskontoen, inkludert frosne beløp.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Merk: Jo høyere risikoprosent, jo lavere risiko, og omvendt.",
  该功能尚未开发: "Denne funksjonen er fortsatt under utvikling",
  重置密码: "Tilbakestill passord",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Skriv inn 8-20 tegn, inkludert bokstaver, tall og spesialtegn",
  修改成功: "Endring vellykket",
  输入验证码: "Skriv inn bekreftelseskode",
  输入密码: "Skriv inn passord",
  详情说明: "Detaljer",
  已售罄: "Utsolgt",
  剩余期限: "Gjenværende løpetid",
  限期: "Løpetid",
  闪兑货币选择: "Velg valuta for rask veksling",
  地区选择: "Velg region",
  "搜索国家/地区": "Søk etter land/region",
  "身份信息已提交，将在*小时内审核完成":
    "Identitetsinformasjon sendt. Behandling vil ta opptil * timer.",
  "选择国家/地区": "Velg land/region",
  "止盈价格需高于*": "Take-profit-pris må være høyere enn *",
  "止损价格需低于*": "Stop-loss-pris må være lavere enn *",
  "止盈价格需低于*": "Take-profit-pris må være lavere enn *",
  "止损价格需高于*": "Stop-loss-pris må være høyere enn *",
  教程详情: "Veiledningsdetaljer",
  请输入止损价: "Skriv inn stop-loss-pris",
  活期: "Fleksibel",
  赎回后立即到账: "Umiddelbar kreditering etter innløsning",
  赎回: "Innløs",
  赎回理财: "Innløs finansprodukt",
  是否赎回当前的理财订单: "Innløse gjeldende finansproduktordre?",
  维护: "Vedlikehold",
  "系统正在维护中……": "Systemet er under vedlikehold...",
  合约: "Futures",
  闪电兑换: "Rask veksling",
  流水挖矿: "Volum-gruvedrift",
  邀请豪礼: "Invitasjonsbonus",
  计算器: "Kalkulator",
  最新价: "Siste pris",
  涨跌幅: "Endring (24h)",
  关注币种添加自选: "Legg til kryptovaluta i favoritter",
  一键添加自选: "Legg til i favoritter (ett klikk)",
  全标已读: "Merk alle som lest",
  无消息: "Ingen meldinger",
  "暂时还没有收到任何消息通知哦!": "Du har ikke mottatt noen varsler ennå!",
  没有更多数据: "Ingen flere data",
  闪兑: "Rask veksling",
  从: "Fra",
  "可用余额：": "Tilgjengelig saldo:",
  至: "Til",
  预览兑换结果: "Forhåndsvis vekslingsresultat",
  闪兑规则: "Regler for rask veksling",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Rask veksling er underlagt markedssvingninger. Det faktisk mottatte beløpet er bindende.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Vekslingskurser fastsettes av tredjeparter. På grunn av kostnader og svingninger kan kursen avvike fra markedskursen. Sjekk nøye.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Plattformen belaster omtrent *% gebyr per veksling for å dekke kostnader på børser.",
  确认汇兑: "Bekreft veksling",
  您预估得到: "Estimert mottak",
  汇兑: "Veksling",
  汇兑比例: "Vekslingskurs",
  刷新: "Oppdater",
  兑换: "Veksle",
  没有更多了: "Ingen flere data",
  搜索币种: "Søk etter kryptovaluta",
  可用: "Tilgjengelig",
  我知道了: "Jeg forstår",
  最新价格: "Siste pris",
  确认: "Bekreft",
  最大: "Maksimum",
  "风险率(%)": "Risikoprosent (%)",
  当前委托: "Gjeldende ordrer",
  合作交易历史记录: "Partner transaksjonshistorikk",
  重置: "Tilbakestill",
  余额: "Saldo",
  现货账户: "Spot-konto",
  合约账户: "Futures-konto",
  WIN账户: "WIN-konto",
  赏金账户: "Bonus-konto",
  总资产折合: "Totale eiendeler (i USDT)",
  今日收益: "Dagens avkastning",
  充币: "Innskudd",
  提币: "Uttak",
  账户权益: "Kontoverdi",
  "数量/类别": "Mengde/Kategori",
  全部币种: "Alle kryptovalutaer",
  全部类型: "Alle typer",
  账单信息: "Fakturainformasjon",
  理财赎回: "Innløsning av finansprodukt",
  购买理财: "Kjøp av finansprodukt",
  收入: "Inntekter",
  支出: "Utgifter",
  到: "til",
  资产划转: "Overføring av eiendeler",
  "最少*": "Minimum *",
  "可用资产：": "Tilgjengelige eiendeler:",
  确认划转: "Bekreft overføring",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Du må overføre eiendeler til riktig konto for å kunne handle. Overføringer mellom kontoer er gratis.",
  币种账户选择: "Velg kryptovaluta-konto",
  选择账户: "Velg konto",
  划转详情: "Overføringsdetaljer",
  划转明细: "Overføringsspesifikasjoner",
  收入账单: "Inntektsfaktura",
  支出账单: "Utgiftsfaktura",
  金额: "Beløp",
  总收益: "Total avkastning",
  佣金: "Provisjon",
  用户名: "Brukernavn",
  "已领取：": "Mottatt:",
  "未领取：": "Ikke mottatt:",
  "请选择国家/地区": "Velg land/region",
  请上传身份信息: "Last opp identitetsinformasjon",
  请选择证件类型: "Velg dokumenttype",
  请填写证件编码: "Skriv inn dokumentnummer",
  请填写名字: "Skriv inn fornavn",
  请填写姓氏: "Skriv inn etternavn",
  投资金额: "Investeringsbeløp",
  天: "dager",
  请输入手机号: "Skriv inn mobilnummer",
  搜索: "Søk",
  搜索历史: "Søkehistorikk",
  热门推荐: "Populære anbefalinger",
  "《Xspace Earn协议》": "Xspace Earn-protokollen",
  我已了解并同意: "Jeg forstår og godtar",
  协议: "Protokoll",
  Xspace官方中文交流群: "Xspace offisielt kinesisk fellesskap",
  Xspace官方英文交流群: "Xspace offisielt engelsk fellesskap",
  预计维护至: "Forventet vedlikehold til",
  更多功能: "Flere funksjoner",
  下载APP: "Last ned app",
  理财: "Finansprodukt",
  推荐: "Anbefalt",
  Telegram官方中文频道: "Offisiell Telegram-kanal (kinesisk)",
  Telegram官方英文频道: "Offisiell Telegram-kanal (engelsk)",
  官方邮箱: "Offisiell e-postadresse",
  客服邮箱: "Kundeservice e-postadresse",
  上述信息最终解释权归官方所有:
    "Ovennevnte informasjon er underlagt offisiell tolkning av plattformen.",
  IOS版下载: "Last ned for iOS",
  Android版下载: "Last ned for Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transaksjonsgebyr = Kjøpsgebyr + Finansieringsrente + Salgsgebyr",
  资金划转: "Overføring av midler",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatisk lukking",
  委托挂单: "Åpen ordre",
  买: "Kjøp",
  卖: "Selg",
  "买入/做多": "Kjøp/Long",
  "卖出/做空": "Selg/Short",
  详情: "Detaljer",
  浮动涨跌: "Urealisert gevinst/tap",
  最小: "Minimum",
  充币数量: "Innskuddsmengde",
  请输入充币数量: "Skriv inn innskuddsmengde",
  支付截图: "Betalingsbevis",
  提交: "Send inn",
  上传驾驶证: "Last opp førerkort",
  上传护照: "Last opp pass",
  加载中: "Laster...",
  上传成功: "Opplasting vellykket",
  充值历史: "Innskuddshistorikk",
  合约卖出手续费: "Futures-salgsgebyr",
  合约买入手续费: "Futures-kjøpsgebyr",
  系统加款: "Systemkreditering",
  系统减款: "Systemdebitering",
  合约资金费率: "Futures-finansieringsrente",
  佣金分成: "Provisjonsdeling",
  U本位合约: "USDT-margin futures",
  资产管理: "Aktivabehandling",
  APP下载: "Last ned app",
  全球领先的数字理财平台:
    "Verdens ledende digitale formuesforvaltningsplattform",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handel umiddelbart med Bitcoin, Ethereum og hundrevis av andre digitale eiendeler",
  "24H涨跌幅": "24h endring",
  查看更多行情: "Se flere markeder",
  近24小时成交量: "24h volum",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Tilbyr hundrevis av spot- og futures-par. Over 20 millioner brukere i 200+ land. En verdensledende digital aktivatjenesteplattform.",
  用户国家分布: "Brukere per land",
  用户数: "Antall brukere",
  交易对: "Handelspar",
  服务支持: "Støtte",
  "随时随地，多平台终端交易": "Handel hvor som helst med flerplattformstøtte",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Kompatibel med flere enheter for alle handelsbehov.",
  随时查看实时行情: "Se sanntidspriser hvor som helst",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Kjøp og selg enkelt BTC, ETH, DOGE og andre digitale eiendeler",
  获取您关注的加密货币价格变化预警:
    "Motta prisvarsler for kryptovalutaer du følger",
  "查看比特币现货、期货、期权价格":
    "Se Bitcoin spot-, futures- og opsjonspriser",
  比较各交易所加密货币价格: "Sammenlign kryptopriser på tvers av børser",
  开启您的数字货币之旅: "Start din reise med digitale eiendeler",
  快捷购买数字货币: "Kjøp kryptovaluta raskt",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handel sikkert og raskt med flere betalingsmetoder",
  最优的交易费率: "De beste transaksjonsgebyrene",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Fordelaktige priser, konkurransedyktige VIP-fordeler og service av høy kvalitet.",
  可信赖的安全保障: "Pålitelig sikkerhet",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Avanserte sikkerhetstiltak og SAFU-fondet beskytter eiendelene dine mot risiko.",
  交易: "Handel",
  币币市场: "Spot-marked",
  "24H成交量": "24h volum",
  交易所: "Børs",
  "24H最高": "24h høy",
  "24H最低": "24h lav",
  永续合约: "Perpetual futures",
  日涨跌: "Daglig endring",
  交易深度: "Ordredybde",
  "资产(合约)": "Eiendeler (Futures)",
  历史仓位: "Posisjonshistorikk",
  兑换记录: "Vekslingshistorikk",
  类型: "Type",
  充值记录: "Innskuddshistorikk",
  划转记录: "Overføringshistorikk",
  类别: "Kategori",
  历史账单: "Fakturahistorikk",
  在线充值: "Nettinnskudd",
  安全设置: "Sikkerhetsinnstillinger",
  用于账户登录使用: "Brukes for kontopålogging",
  用户提现时安全验证使用: "Brukes for sikkerhetsverifisering ved uttak",
  验证: "Verifiser",
  万: "million",
  随时随地开启交易: "Begynn å handle hvor som helst",
  "*货币交易所的所有功能尽在你的手中。":
    "Alle funksjonene til * kryptobørsen i hånden din.",
  "下载*货币交易所APP。": "Last ned * kryptobørs-appen.",
  下载自: "Last ned fra",
  内测版: "Betaversjon",
  下载: "Last ned",
  扫码下载: "Skann for å laste ned",
  设置您的资产密码: "Sett ditt aktivapassord",
  法币: "Fiat",
  我要买: "Jeg vil kjøpe",
  我要卖: "Jeg vil selge",
  请输入金额: "Skriv inn beløp",
  汇率: "Vekslingskurs",
  获得: "Få",
  支付通道: "Betalingskanal",
  收款通道: "Mottakskanal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Sørg for at mottakskanalen er i ditt navn når du selger.",
  当前法币暂不支持交易对可尝试前往提现:
    "Dette fiat-paret støttes for øyeblikket ikke. Prøv et uttak.",
  前往提现: "Gå til uttak",
  该法币暂无通道: "Ingen tilgjengelig kanal for denne fiat-valutaen",
  "正在出售中，请耐心等待": "Salg pågår, vennligst vent",
  请选择支付通道: "Velg betalingskanal",
  请选择方式: "Velg metode",
  法币历史: "Fiat-historikk",
  买币: "Kjøp krypto",
  卖币: "Selg krypto",
  失败: "Mislyktes",
  已完成: "Fullført",
  未付款: "Ubetal",
  待审核: "Under behandling",
  打款中: "Utbetaling pågår",
  订单详情: "Ordredetaljer",
  联系客服: "Kontakt kundeservice",
  到账金额: "Mottatt beløp",
  通道: "Kanal",
  收款人: "Mottaker",
  收款账户: "Mottakerkonto",
  "订单出售失败，请查下方失败原因":
    "Salg av ordre mislyktes. Se årsaken nedenfor.",
  失败原因: "Årsak til feil",
  您还未进行付款: "Du har ikke betalt ennå",
  您已成功购买: "Kjøpet var vellykket",
  已取消订单: "Ordre kansellert",
  "订单正在审核中，请耐心等待": "Ordren behandles. Vennligst vent.",
  您已成功出售: "Salget var vellykket",
  "订单正在打款中，请耐心等待": "Utbetaling pågår. Vennligst vent.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "For betaling må du besøke en annen plattform. Vær oppmerksom på informasjonssikkerheten din.",
  当前法币暂不支持交易对可尝试前往充值:
    "Dette fiat-paret støttes for øyeblikket ikke. Prøv et innskudd.",
  前往充值: "Gå til innskudd",
  购买: "Kjøp",
  订单号: "Ordrenummer",
  单价: "Enhetspris",
  到账数量: "Mottatt mengde",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Det finnes en ubetalt ordre. Vil du starte en ny betalingsordre?",
  继续支付: "Fortsett betaling",
  重新下单: "Ny bestilling",
  是否确定出售: "Er du sikker på at du vil selge?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Etter bekreftelse vil plattformen tildele en kjøper. Vent på matchingen.",
  出售: "Selg",
  收款方式: "Mottaksmetode",
  订单已生成: "Ordre generert",
  取消订单: "Kanseller ordre",
  请在: "Vennligst innen",
  内完成付款: "fullfør betalingen",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Forlat plattformen, logg inn på din valgte betalingsmetode og overfør beløpet til selgerens følgende konto. Oppgi alltid referansen:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Uten referanse kan ikke selgeren bekrefte betalingen, noe som kan føre til tap av eiendeler.",
  "未在规定的时间内付款，订单都将被取消。":
    "Hvis du ikke betaler innen den angitte tiden, vil ordren bli kansellert.",
  姓名: "Navn",
  收款姓名: "Mottakers navn",
  开户支行: "Bankfilial",
  银行卡号: "Bankkortnummer",
  "付款后，返回本平台": "Etter betaling, returner til denne plattformen",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Klikk på knappen 'Jeg har fullført betalingen, varsel selger'",
  未点击卖家不会放款:
    "Selgeren vil først frigjøre kryptoen etter at du har klikket på knappen",
  交易条款: "Transaksjonsvilkår",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Midlene for kjøpet må være lovlige og trygge",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Svindel, pyramidespill, gambling eller andre ulovlige midler er ikke tillatt",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Hvis midlene fryses eller er mistenkelige etter transaksjonen, vil vi ikke frigjøre USDT og vil gi en refusjon",
  "已付款，通知卖家": "Betalt, varsle selger",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Hvis du kansellerer totalt * ordre i dag, vil kjøperetten din for dagen bli tilbakekalt. Kansellere denne ordren?",
  添加收款方式: "Legg til mottaksmetode",
  是否删除此收款方式: "Slette denne mottaksmetoden?",
  删除: "Slett",
  请选择法币: "Velg fiat-valuta",
  机构名称: "Navn på institusjon",
  请选择机构: "Velg institusjon",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Din valgte mottaksmetode vil vises til kjøpere når du selger krypto. Sørg for at dataene er korrekte.",
  请选择银行: "Velg bank",
  请输入姓名: "Skriv inn navn",
  账号: "Kontonummer",
  请输入账号: "Skriv inn kontonummer",
  收款码: "Mottakskode",
  "银行账号/卡号": "Bankkonto/Kortnummer",
  "请输入银行账号/卡号": "Skriv inn bankkonto/kortnummer",
  "开户支行（选填）": "Bankfilial (valgfritt)",
  请输入开户支行: "Skriv inn bankfilial",
  "加入*官方频道": "Bli med i den offisielle *-kanalen",
  关于: "Om",
  条款: "Vilkår",
  成功: "Vellykket",
  等待: "Vent",
  作废: "Ugyldig",
  确认付款: "Bekreft betaling",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Betaling fullført? Etter bekreftelse vil selgeren bekrefte mottak innen * minutter.",
  最大金额: "Maksimalt beløp",
  最小金额: "Minimumsbeløp",
  付款: "Betal",
  法币充值: "Fiat-innskudd",
  法币提现: "Fiat-uttak",
  待支付: "Venter på betaling",
  已支付: "Betalt",
  商户名: "Selgernavn",
  当前没有添加支付方式: "Ingen betalingsmetode lagt til",
  添加后再出售: "Legg til en før du selger",
  新人大礼包: "Velkomstpakke",
  注册即可领取: "Motta etter registrering",
  立即领取: "Motta nå",
  不再提示: "Ikke vis igjen",
  "该奖励需在APP中领取，请下载APP":
    "Denne belønningen kan bare mottas i appen. Last ned appen.",
  去交易: "Gå til handel",
  期权交易: "Opsjonshandel",
  交易额: "Handelsbeløp",
  可用额度: "Tilgjengelig grense",
  交易周期: "Handelsperiode",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Short",
  当前持有: "Nåværende posisjon",
  胜率: "Vinnprosent",
  "盈利/亏损数": "Antall gevinst/tap-transaksjoner",
  累计实现盈亏: "Realisert total gevinst/tap",
  秒: "sekunder",
  分: "minutter",
  小时: "timer",
  周: "uke",
  下单时间: "Ordretid",
  剩余时间: "Gjenstående tid",
  买入价: "Kjøpspris",
  结算价: "Avregningspris",
  实现盈利: "Realisert gevinst",
  结算时间: "Avregningstid",
  期权: "Opsjon",
  新手教程: "Veiledning for nybegynnere",
  我的订单: "Mine ordrer",
  赔率: "Odds",
  全部订单: "Alle ordrer",
  持有订单: "Åpne ordrer",
  历史订单: "Ordrehistorikk",
  输入交易额度: "Skriv inn handelsbeløp",
  选择交易周期: "Velg handelsperiode",
  去注册: "Registrer deg",
  冻结: "Frys",
  期权支出: "Opsjonskostnad",
  期权收入: "Opsjonsinntekt",
  用户提现: "Brukeruttak",
  "是否购买？": "Kjøp denne opsjonen?",
  购买成功: "Kjøp vellykket",
  请签名: "Vennligst signer",
  提交签名: "Send signatur",
  清空签名: "Tøm signatur",
  签名审核中: "Signatur under behandling",
  已提交: "Sendt",
  扫一扫下载APP: "Skann for å laste ned appen",
  新手领取大礼包: "Velkomstpakke for nye brukere",
  注册实名即送彩金: "Registrer og verifiser for å motta bonus",
  交易总额: "Totalt handelsvolum",
  资产不足: "Utilstrekkelige eiendeler",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Utilstrekkelige eiendeler på WIN-kontoen. Du kan overføre eiendeler fra hovedkontoen din.",
  Win: "WIN",
  比赛: "Konkurranse",
  未开始: "Ikke startet",
  赛程: "Program",
  赛果: "Resultat",
  已结束: "Avsluttet",
  让球: "Handicap",
  进球数: "Mål",
  大: "Over",
  小: "Under",
  胜负平: "1X2 (Seier/Uavgjort/Tap)",
  和局: "Uavgjort",
  投注: "Innsats",
  下注金额: "Innsatsbeløp",
  下注: "Plasser innsats",
  阵容: "Lagoppstilling",
  分析: "Analyse",
  输入下注金额: "Skriv inn innsatsbeløp",
  下注成功: "Innsats plassert",
  投注记录: "Innstatshistorikk",
  未结算: "Ikke avregnet",
  已结算: "Avregnet",
  流水: "Omsetning",
  输赢: "Gevinst/Tap",
  赛时: "Kamp tid",
  下注时间: "Innsatstid",
  足彩竞猜: "Fotballtipping",
  查看详情: "Se detaljer",
  输: "Tap",
  赢: "Gevinst",
  主: "Hjemme",
  客: "Borte",
  主胜: "Hjemmeseier",
  客胜: "Borteseier",
  平: "Uavgjort",
  已延期: "Utsatt",
  账号异常: "Kontoavvik",
  全场独赢: "Fulltid 1X2",
  全场让球: "Fulltid Handicap",
  全场大小: "Fulltid Over/Under",
  总进球: "Totalt antall mål",
  拍摄照片要求: "Fotokrav",
  标准拍摄: "Standardbilde",
  边框缺失: "Manglende kant",
  照片模糊: "Uskarpt bilde",
  闪光强烈: "For sterkt blitz",
  上传手持证件照: "Last opp bilde med dokument i hånden",
  上传证件照: "Last opp dokumentbilde",
  换一张: "Nytt bilde",
  出生日期: "Fødselsdato",
  请选择出生日期: "Velg fødselsdato",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Skriv inn verifiseringskoden nedenfor for å få en e-postkode for registrering.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Du har fortsatt * verifiseringsforsøk igjen. Etter denne grensen kan du ikke verifisere deg.",
  上半场: "1. omgang",
  下半场: "2. omgang",
  独赢: "1X2",
  上半场独赢: "1. omgang 1X2",
  下半场独赢: "2. omgang 1X2",
  上半场让球: "1. omgang Handicap",
  下半场让球: "2. omgang Handicap",
  上半场大小球: "1. omgang Over/Under",
  下半场大小球: "2. omgang Over/Under",
  波胆: "Korrekt resultat",
  上半场波胆: "1. omgang Korrekt resultat",
  下半场波胆: "2. omgang Korrekt resultat",
  单双: "Odd/Eller",
  单: "Odd",
  双: "Eller",
  上半场单双: "1. omgang Odd/Eller",
  下半场单双: "2. omgang Odd/Eller",
  上半场总进球: "1. omgang Totalt mål",
  下半场总进球: "2. omgang Totalt mål",
  中场: "Hvil",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Merk: For bildet med dokument i hånden, skriv teksten på et hvitt ark og fotografer det sammen med dokumentet ditt, som i eksemplet.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Nylig har mange svindelkontoer blitt straffet. Kontakt kundeservice hvis du mener at kontoen din er urettferdig straffet.",
  最小下注金额: "Minimum innsats",
  参与活动最小下注金额: "Minimum innsats for å delta i aktiviteten",
  记住密码: "Husk passord",
  比分: "Resultat",
  "您还未登录，请先登录": "Du er ikke logget inn. Logg inn først.",
  立即登录: "Logg inn nå",
  下注限额: "Innsatsgrense",
  可赢金额: "Beløp som kan vinnes",
  闪兑详情: "Detaljer for rask veksling",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "På grunn av valutakurssvingninger kan det endelige innsatsbeløpet avvike. Ordren er bindende.",
  开赛时间: "Starttid",
  足球收入: "Fotballinntekter",
  足球支出: "Fotballutgifter",
  活动详情: "Aktivitetsdetaljer",
  为世界杯喝彩: "Støtt verdensmesterskapet",
  我的竞猜: "Mine tips",
  "竞猜比赛、有机会瓜分*USDT": "Tips om kamper og vinn en del av * USDT",
  "瓜分*USDT": "Del * USDT",
  距离活动结束还有: "Aktivitet slutter om:",
  我的门票: "Mine billetter",
  竞猜结束时间: "Slutt på tipping",
  猜比分: "Tips resultat",
  "福利派送中，完成任务即可获取门票":
    "Bonuser deles ut. Fullfør oppgaver for å tjene billetter.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Fullfør følgende oppgaver for å få tilsvarende antall billetter for å delta i konkurransen.",
  时: "time",
  活动: "Aktivitet",
  竞猜记录: "Tippinghistorikk",
  结果: "Resultat",
  任务: "Oppgave",
  去邀请: "Inviter",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tips om resultatet for hver kamp og vinn en del av $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "En billett er nødvendig for å tipse. Billetter kan tjenes ved å fullføre plattformoppgaver.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Etter et vellykket tips, send et skjermbilde til kundeservice. De vil kreditere bonusen til kontoen din, som du umiddelbart kan ta ut.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Juks er forbudt. Hvis det oppdages, vil belønningen bli ugyldig.",
  "完成任务后，点击咨询客服获得门票。":
    "Etter å ha fullført oppgavene, klikk 'Kontakt kundeservice' for å få billetter.",
  继续猜: "Fortsett å tipse",
  总单数: "Totalt antall spill",
  赛事筛选: "Filtrer etter arrangement",
  球队筛选: "Filtrer etter lag",
  总金额: "Totalt beløp",
  总流水: "Total omsetning",
  派奖金额: "Bonusbeløp utbetalt",
  下注单数: "Antall spill",
  利润: "Profitt",
  更多福利: "Flere bonuser",
  我的奖金: "Min bonus",
  未认证: "Ikke verifisert",
  总量: "Total",
  或: "eller",
  模拟交易: "Demo-handel",
  体验账户不可操作: "Ikke tilgjengelig på demo-konto",
  世界杯比分竞猜: "VM-resultattipping",
  "领*USDT起": "Motta fra * USDT",
  消息: "Meldinger",
  滚球: "Live-spill",
  是: "Ja",
  不是: "Nei",
  当前余额: "Nåværende saldo",
  KOL招募: "KOL-rekruttering",
  本月净输赢: "Netto gevinst/tap denne måneden",
  本月佣金: "Provisjon denne måneden",
  佣金比例: "Provisjonsprosent",
  活跃人数: "Aktive brukere",
  新增下级: "Nye nedlinjer",
  登录人数: "Innloggede brukere",
  首存人数: "Brukere med første innskudd",
  数据分析: "Dataanalyse",
  人数: "Antall personer",
  新注册存款金额: "Innskuddsbeløp for nye registreringer",
  老用户存款金额: "Innskuddsbeløp for eksisterende brukere",
  首存金额: "Første innskuddsbeløp",
  快捷入口: "Hurtigtilgang",
  成员管理: "Medlemsadministrasjon",
  财务报表: "Finansielle rapporter",
  分红报表: "Utbytterapport",
  订单记录: "Ordrehistorikk",
  VIP专享: "VIP-eksklusivt",
  推广工具: "Markedsføringsverktøy",
  计算规则: "Beregningsregler",
  账变明细: "Transaksjonsdetaljer",
  成员: "Medlemmer",
  下级概览: "Oversikt over nedlinjer",
  下级成员总计: "Totalt nedlinjer",
  本月新增: "Nye denne måneden",
  本月活跃会员: "Aktive medlemmer denne måneden",
  今日活跃会员: "Aktive medlemmer i dag",
  本月有效活跃: "Effektivt aktive denne måneden",
  活跃成员占比: "Andel aktive medlemmer",
  本月活跃: "Aktive denne måneden",
  今日活跃: "Aktive i dag",
  下级成员: "Nedlinjer",
  会员账号: "Medlemskonto",
  统计时间: "Statistikktid",
  筛选: "Filtrer",
  存款: "Innskudd",
  取款: "Uttak",
  总输赢: "Totalt gevinst/tap",
  是否有效用户: "Aktiv bruker?",
  最近登录时间: "Siste pålogging",
  否: "Nei",
  开始时间: "Starttid",
  结束时间: "Sluttid",
  提取: "Ta ut",
  总盈亏: "Totalt resultat",
  净盈亏: "Nettoresultat",
  分红: "Utbytte",
  概览: "Oversikt",
  月度详细数据: "Månedlige detaljdata",
  未发放: "Ikke utbetalt",
  活跃用户: "Aktive brukere",
  有效新增会员: "Effektive nye medlemmer",
  冲正后净输赢: "Netto gevinst/tap etter korreksjon",
  上月结余: "Saldo forrige måned",
  净输赢: "Netto gevinst/tap",
  "系统每日新加坡时间1:00更新一次报表":
    "Rapporter oppdateres daglig kl. 01:00 Singapore-tid.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "I rapportene betyr positive tall profitt for partneren, negative tall betyr tap for partneren.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Provisjonsdata oppdateres daglig, er veiledende og utgjør ikke et endelig utbetalingsgrunnlag.",
  选择时间: "Velg tid",
  足球: "Fotball",
  投注金额: "Innsatsbeløp",
  有效订单: "Gyldige ordrer",
  下级账户: "Nedlinjekonto",
  待成交: "Venter",
  下单金额: "Ordrebeløp",
  订单内容: "Ordreinnhold",
  秒数: "Sekunder",
  联赛: "Liga",
  队伍: "Lag",
  比赛时间: "Kampstart",
  玩法: "Spilltype",
  等级规则表: "Nivåregeltabell",
  等级: "Nivå",
  活跃会员: "Aktive medlemmer",
  最新活跃: "Siste aktivitet",
  额外佣金: "Ekstra provisjon",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Månedlig basert på vekststandarder. Du kan bare dra nytte av ett nivå.",
  渠道生成: "Generer kanal",
  创建: "Opprett",
  渠道名称: "Kanalnavn",
  注册人数: "Antall registreringer",
  浏览人数: "Antall visninger",
  构建状态: "Byggestatus",
  禁用: "Deaktiver",
  启用: "Aktiver",
  查看: "Se",
  创建渠道: "Opprett kanal",
  创建成功: "Opprettelse vellykket",
  操作成功: "Handling vellykket",
  渠道详情: "Kanaldetaljer",
  邀请码: "Invitasjonskode",
  访问人数: "Antall besøkende",
  渠道地址: "Kanaladresse",
  我的福利: "Mine bonuser",
  充值福利: "Innskuddsbonus",
  当前流水: "Nåværende omsetning",
  如何参与: "Hvordan delta",
  币种充值: "Kryptovaluta-innskudd",
  充值福利中领取福利: "Motta bonus i innskuddsbonus",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regel: Innskuddsbonusen er frivillig, gyldig i 24 timer etter innskudd. Etter mottak vil uttak bli midlertidig blokkert til omsetningskravet er nådd.",
  失效日期: "Utløpsdato",
  "暂无福利领取，充值后领取": "Ingen bonus tilgjengelig. Motta etter innskudd.",
  参与: "Delta",
  充值赠送: "Innskuddsbonus",
  "领取*%的赠送": "Motta *% bonus",
  去领取: "Motta",
  VIP奖励: "VIP-belønning",
  "当前可领取*USDT，是否确认领取": "* USDT tilgjengelig for mottak. Bekreft?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Etter mottak vil uttak bli midlertidig blokkert til en omsetning på * USDT er nådd.",
  充值送大礼: "Innskuddsgave",
  "存入越多，送越多！": "Jo mer du setter inn, jo større gave!",
  无效: "Ugyldig",
  有效: "Gyldig",
  总存金额: "Totalt innskuddsbeløp",
  提示: "Merknad",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positive tall i totalt og netto gevinst/tap betyr plattformprofitt. Daglige data er veiledende.",
  "净盈亏：总盈亏-用户返水":
    "Nettoresultat: Totalt resultat - Cashback til bruker",
  盈利方: "Profittpart",
  代理: "Agent",
  客户: "Kunde",
  平局: "Uavgjort",
  平台: "Plattform",
  "已提交审核，请耐心等待": "Sendt for verifisering. Vennligst vent.",
  充值日期: "Innskuddsdato",
  平台本月总输赢: "Plattformens totale gevinst/tap denne måneden",
  KOL招募合作: "KOL-rekrutteringssamarbeid",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Plattformen åpner KOL-rekruttering. Med en sosiale medier-konto kan du nyte utbytte og livslang inntekt gjennom engangskundeverving.",
  级别: "Nivå",
  平台利润返佣: "Plattformprofittprovisjon",
  佣金案例: "Provisjonseksempel",
  交易项目: "Handelsprodukter",
  "期权交易、合约交易、足球游戏": "Opsjonshandel, futureshandel, fotballspill",
  报名方式: "Påmeldingsmetode",
  点击KOL招募报名: "Klikk for å melde deg på KOL-rekruttering",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Velkommen til teamet vårt. Vi støtter deg i å bygge ditt eget brukersystem. Tjen opptil *% provisjon. Vi gleder oss til din deltakelse.",
  输入联系方式: "Skriv inn kontaktinformasjon",
  最低活跃人数: "Minimum antall aktive brukere",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "F.eks.: Hvis aktive brukere denne måneden ≥ * og plattformens totale gevinst/tap ≥ * USDT, tilhører du nivå * og får *% provisjon.",
  比分竞猜: "Resultattipping",
  豪礼相赠: "Stor gave",
  足球活动: "Fotballaktivitet",
  圣诞节活动: "Juleaktivitet",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Du har deltatt i en aktivitet. Uttak er midlertidig blokkert. Du trenger fortsatt * USDT i omsetning for å låse opp.",
  剩余流水: "Gjenstående omsetning",
  助力足球: "Støtt fotball",
  佣金累计: "Total provisjon",
  有效投注: "Gyldige spill",
  今日: "I dag",
  今日返水: "Cashback i dag",
  VIP返水: "VIP-cashback",
  返水记录: "Cashback-historikk",
  成员信息: "Medlemsinformasjon",
  基本信息: "Grunnleggende informasjon",
  钱包余额: "Lommeboksaldo",
  投注信息: "Spillinformasjon",
  返水: "Cashback",
  总下注: "Total innsats",
  今日输赢: "Gevinst/tap i dag",
  下注动态: "Spillaktivitet",
  返水奖励: "Cashback-belønning",
  分红金额: "Utbyttebeløp",
  返水支出: "Cashback-kostnad",
  总返水: "Total cashback",
  流水总额: "Total omsetning",
  返水总额: "Total cashback",
  返水详情: "Cashback-detaljer",
  日流水: "Daglig omsetning",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Plattformen gir ekstra cashback basert på daglig omsetning av nedlinjene dine. Utbetaling daglig kl. 00:00 Singapore-tid til bonus-konto.",
  "申请成功，等待审核": "Søknad vellykket, venter på verifisering",
  "我出本金，盈利共分享": "Jeg gir kapital, profitt deles",
  最高分红: "Maksimalt utbytte",
  投资大师比赛: "Master Investor-konkurranse",
  "我出本金，你盈利": "Jeg gir kapital, du tjener",
  共分享: "Del sammen",
  最高分红可得: "Maksimalt mulig utbytte",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Eksklusiv velkomstbonus: $* gratis. Etter mottak kan du investere i ethvert prosjekt. Profitt kan umiddelbart tas ut.",
  报名领取: "Meld deg på og motta",
  审核驳回: "Verifisering avvist",
  驳回原因: "Årsak til avvisning",
  活动运行周期: "Aktivitetsperiode",
  "申请成功后起至*天内完成超额收益。":
    "Oppnå overavkastning innen * dager etter godkjenning.",
  分红比: "Utbytteratio",
  "*日获得盈利后，可获得*%的收益额。":
    "Etter å ha oppnådd profitt på dag *, mottar du *% av avkastningsbeløpet.",
  参与条件: "Deltakelsesbetingelser",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Brukere fra Russland eller Tyrkia som ikke har deltatt ennå.",
  计算项目: "Beregnede produkter",
  "合约、体育、期权": "Futures, Sport, Opsjoner",
  我的投资: "Mine investeringer",
  参与天数: "Deltakelsesdager",
  累计下注: "Total innsats",
  累计盈亏: "Totalt gevinst/tap",
  预计可分红: "Forventet utbytte",
  常见问题: "Ofte stilte spørsmål (FAQ)",
  什么是平台出资: "Hva er plattformfinansiering?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Plattformen gir gratis midler til brukere fra bestemte land for å investere i prosjekter.",
  怎么获取平台出资的福利: "Hvordan får jeg plattformfinansieringsbonusen?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Hvis du er fra ett av de angitte landene, klikk på påmeldingsknappen. Etter godkjenning vil * USDT bli overført til bonus-kontoen din, som du kan overføre for å investere.",
  什么是分红: "Hva er utbytte?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Utbytte: Hvis avkastningen når 100% innen den angitte tiden, mottar du 50% av overavkastningen. F.eks.: Motta 100 USDT, oppnå 120% avkastning, da er 20% overavkastning.",
  "如何取得分红？": "Hvordan får jeg utbytte?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Aktivitetsyklusen er hver * dag. Etter fullføring foretas avregning. Hvis du oppfyller kravene, sendes utbyttet til bonus-kontoen. Hvis ikke, vil avkastningen din og plattformfinansieringen fjernes.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Deltakende kontoer må være KYC-verifisert. Kun én bonus per konto.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC for deltakelse er kun gyldig for angitte land. Sjekk om ditt land samsvarer med aktivitetslandet.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Etter vellykket deltakelse vil uttak bli midlertidig blokkert til aktiviteten er fullført.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Følg aktivitetsreglene. Ved juks eller misbruk av systemfeil, vil alle midler på kontoen din bli permanent frosset.",
  平台出资: "Plattformfinansiering",
  平台出资收回: "Plattformfinansiering tilbakekalt",
  投资大师奖励: "Master Investor-belønning",
  请下载APP添加收款方式: "Last ned appen for å legge til mottaksmetode",
  请下载APP进行身份验证: "Last ned appen for å utføre identitetsverifisering",
  请下载APP参与: "Last ned appen for å delta",
  技术指标: "Tekniske indikatorer",
  主图: "Hoveddiagram",
  副图: "Sekundært diagram",
  新注册人数: "Nye registreringer",
  老用户存款人数: "Eksisterende brukere som setter inn",
  存款人数: "Antall innskudd",
  取款人数: "Antall uttak",
  投注人数: "Antall spill",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Ekskludert brukere fra Indonesia, India, Bangladesh som ikke har deltatt ennå.",
  市场动态: "Markedsdynamikk",
  外汇合约: "Forex-futures",
  盈亏比: "Gevinst/tap-forhold",
  委托价: "Ordrepris",
  可用余额: "Tilgjengelig saldo",
  持仓额: "Posisjonsverdi",
  强平价: "Likvideringspris",
  修改: "Endre",
  修改价位: "Endre pris",
  外汇: "Forex",
  外汇账户: "Forex-konto",
  我的交易: "Mine transaksjoner",
  未设置: "Ikke satt",
  超出最大可设数值: "Overskrider maksimal innstillbar verdi",
  超出最小可设数值: "Under minimal innstillbar verdi",
  止盈超出最小可设数值: "Take-profit under minimal innstillbar verdi",
  止损超出最大可设数值: "Stop-loss overskrider maksimal innstillbar verdi",
  止盈超出最大可设数值: "Take-profit overskrider maksimal innstillbar verdi",
  止损超出最小可设数值: "Stop-loss under minimal innstillbar verdi",
  挖矿: "Gruvedrift",
  交易账户: "Handelskonto",
  买涨: "Kjøp (Long)",
  买跌: "Selg (Short)",
  请输入正确的银行卡信息: "Skriv inn korrekt bankkortinformasjon",
  联系在线客服: "Kontakt live kundeservice",
  法币交易请联系在线客服: "Kontakt kundeservice for fiat-handel",
  提交订单: "Send ordre",
  "支付过程如有疑问,请联系在线客服":
    "Kontakt kundeservice hvis du har spørsmål om betalingsprosessen",
  彩金赠送: "Bonustildeling",
  在线客服: "Live chat",
  最少投资: "Minimumsinvestering",
  "提交时间:": "Innsendelsestid:",
  提现拒绝: "Uttak avvist",
  认证拒绝: "Verifisering avvist",
  认证通过: "Verifisering godkjent",
  请输入正确的交易额度: "Skriv inn et gyldig handelsbeløp",
  最大下注金额: "Maksimal innsats",
  手机号: "Mobilnummer",
  邮箱注册: "Registrer med e-post",
  手机号注册: "Registrer med mobilnummer",
  查询: "Søk",
  手机号登录: "Logg inn med mobilnummer",
  邮箱登录: "Logg inn med e-post",
  请输入数量: "Skriv inn mengde",
  可用数量: "Tilgjengelig mengde",
  钱包登录: "Logg inn med lommebok",
  请输入正确的邀请码: "Skriv inn en gyldig invitasjonskode",
  "请输入邀请码(必填)": "Skriv inn invitasjonskode (obligatorisk)",
  输入正确的金额: "Skriv inn et gyldig beløp",
  法币充值: "Fiat-innskudd",
  卢比充值: "Indisk rupi-innskudd",
  请输入法币: "Skriv inn fiat-beløp",
  请输入IFSC: "Skriv inn IFSC-kode",
  "银行编码(选填)": "Bankkode (valgfritt)",
  请输入银行编码: "Skriv inn bankkode",
  请输入大于8位数的密码: "Skriv inn et passord med mer enn 8 tegn",
  添加成功: "Lagt til",
  "60秒": "60 sekunder",
  "180秒": "180 sekunder",
  "300秒": "300 sekunder",
  "2次密码不一致": "Passordene er ikke like",
  输入提币数量: "Skriv inn uttaksmengde",
  图片格式不正确: "Ugyldig bildeformat",
  图片大于20M: "Bildet er større enn 20 MB",
  请设置委托价格: "Sett en ordrepris",
  输入资金密码: "Skriv inn aktivapassord",
  验证码错误: "Feil bekreftelseskode",
  充值拒绝: "Innskudd avvist",
  请输入SSN: "Skriv inn SSN",
  结算完成: "Avregning fullført",
  继续下单: "Fortsett å bestille",
  限价: "Limitordre",
  买入价格: "Kjøpspris",
  买入量: "Kjøpsmengde",
  卖出价格: "Salgspris",
  卖出量: "Salgsmengde",
  买入: "Kjøp",
  卖出: "Selg",
  订单创建成功: "Ordre opprettet",
  币币买入支出: "Kostnad for spotkjøp",
  币币买入支出退还: "Refusjon av kostnad for spotkjøp",
  币币买入获得: "Mottak fra spotkjøp",
  币币卖出支出: "Kostnad for spotsalg",
  币币卖出支出退还: "Refusjon av kostnad for spotsalg",
  币币卖出获得: "Mottak fra spotsalg",
  币币交易手续费: "Spot transaksjonsgebyr",
  请输入限价: "Skriv inn limitpris",
  成交: "Utført",
  等待成交: "Venter på utførelse",
  交易完成: "Transaksjon fullført",
  被取消: "Kansellert",
  交易时间: "Transaksjonstid",
  法币交易: "Fiat-handel",
  法币出售: "Fiat-salg",

  两次密码不一致: "Passordene er ikke like",
  再次输入账户密码: "Skriv inn kontopassordet på nytt",

  美国: "USA",
  韩国: "Sør-Korea",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikanske Jomfruøyer",
  英属处女群岛: "Britiske Jomfruøyer",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Usbekistan",
  乌拉圭: "Uruguay",
  英国: "Storbritannia",
  阿拉伯联合酋长国: "De forente arabiske emirater",
  乌克兰: "Ukraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- og Caicosøyene",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Tyrkia",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad og Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Øst-Timor",
  泰国: "Thailand",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tadsjikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syria",
  瑞士: "Sveits",
  瑞典: "Sverige",
  斯威士兰: "Eswatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spania",
  南非: "Sør-Afrika",
  索马里: "Somalia",
  所罗门群岛: "Salomonøyene",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovakia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (nederlandsk del)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellene",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi-Arabia",
  圣多美和普林西比: "São Tomé og Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts og Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent og Grenadinene",
  圣彼埃尔和密克隆岛: "Saint-Pierre og Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts og Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Russland",
  罗马尼亚: "Romania",
  留尼汪: "Réunion",
  刚果共和国: "Republikken Kongo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Filippinene",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Ny-Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norge",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "New Zealand",
  新喀里多尼亚: "Ny-Caledonia",
  荷属安德列斯群岛: "Nederlandske Antiller",
  荷兰: "Nederland",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mosambik",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolia",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Mexico",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Marianene",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldivene",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Nord-Makedonia",
  中国澳门: "Macao",
  卢森堡: "Luxembourg",
  立陶宛: "Litauen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libya",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Latvia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgisistan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kasakhstan",
  约旦: "Jordan",
  日本: "Japan",
  牙买加: "Jamaica",
  象牙海岸: "Elfenbenskysten",
  意大利: "Italia",
  以色列: "Israel",
  爱尔兰: "Irland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesia",
  印度: "India",
  冰岛: "Island",
  匈牙利: "Ungarn",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grønland",
  希腊: "Hellas",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Tyskland",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Fransk Polynesia",
  法属圭亚那: "Fransk Guyana",
  法国: "Frankrike",
  芬兰: "Finland",
  斐济: "Fiji",
  法罗群岛: "Færøyene",
  埃塞俄比亚: "Etiopia",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Ekvatorial-Guinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypt",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Den dominikanske republikk",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Danmark",
  捷克: "Tsjekkia",
  塞浦路斯: "Kypros",
  库拉索: "Curaçao",
  古巴: "Cuba",
  克罗地亚: "Kroatia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Elfenbenskysten",
  库克群岛: "Cookøyene",
  科摩罗: "Komorene",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Tsjad",
  中非共和国: "Den sentralafrikanske republikk",
  佛得角: "Kapp Verde",
  开曼群岛: "Caymanøyene",
  开普: "Cape",
  加拿大: "Canada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodsja",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brasil",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia-Hercegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgia",
  白俄罗斯: "Hviterussland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Aserbajdsjan",
  奥地利: "Østerrike",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua og Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikansk Samoa",
  阿尔及利亚: "Algerie",
  中国: "Kina",
  余额不足: "Utilstrekkelig saldo",
  最低购买: "Minimumskjøp",
  最高购买: "Maksimumskjøp",
  下单成功: "Ordre lagt inn",
  平仓成功: "Posisjon lukket",
  请输入正确的平仓数量: "Skriv inn en gyldig lukkingsmengde",
  加仓成功: "Posisjon økt",
  请输入正确的加仓金额: "Skriv inn et gyldig beløp for å øke posisjonen",
  收藏成功: "Lagt til i favoritter",
  取消收藏成功: "Fjernet fra favoritter",
  加密币永续: "Kryptovaluta perpetual",
  外汇永续: "Forex perpetual",
  期权账户: "Opsjonskonto",
  快捷卖币: "Raskt salg av krypto",

  托管资金: "Forvaltede midler",
  托管中: "Under forvaltning",
  预计日收益: "Estimert daglig avkastning",
  累计收益: "Total avkastning",
  周期: "Løpetid",
  日收益: "Daglig avkastning",
  限额: "Grense",
  立即托管: "Start forvaltning nå",
  "已鎖定 請聯繫客服": "Låst. Kontakt kundeservice.",
  产品列表: "Produktliste",
  规则: "Regler",
  创建订单: "Opprett ordre",
  产品名称: "Produktnavn",
  托管周期: "Forvaltningsperiode",
  等级限制: "Nivåbegrensning",
  托管金额: "Forvaltet beløp",
  限额: "Grense",
  余额: "Saldo",
  购买日: "Kjøpsdato",
  起息日: "Rentestartdato",
  派息时间: "Renteutbetalingstid",
  每天: "Daglig",
  计息结束日: "Rentesluttdato",
  每日收益: "Daglig avkastning",
  预计收益: "Estimert avkastning",
  "收益将自动发送至您的余额账户;":
    "Avkastning sendes automatisk til din saldo;",
  "您的资金没有任何风险;": "Mine midler er uten risiko;",
  "365*24小时不断地工作;": "Jobber 24/7, 365 dager i året;",
  托管中: "Under forvaltning",
  结束: "Avsluttet",
  今日收益: "Dagens avkastning",
  剩余周期: "Gjenværende løpetid",
  进行中: "Aktiv",
  已发放: "Utbetalt",
  信誉分: "Omdømmepoeng",

  复制成功: "Kopiert vellykket",
  VIP权益: "VIP-fordeler",
  旧密码: "Gammelt passord",
  请输入旧密码: "Vennligst skriv inn det gamle passordet",
  "忘记旧密码请联系客服重置。":
    "Hvis du har glemt det gamle passordet, vennligst kontakt kundeservice for å tilbakestille det.",
  去升级: "Oppgrader",
  描述: "Beskrivelse",
  实际存款金额: "Faktisk innskuddsbeløp",
  升级礼金: "Oppgraderingsbonus",
  隔夜利息: "Overnattingsrente (swap)",
  自动结算: "Automatisk oppgjør",
  等级规则: "Nivåregler",
  "WEB3.0币持有数据收益": "WEB3.0-mynthold data avkastning",
  总生产: "Total produksjon",
  有效节点: "Aktive noder",
  参与人: "Deltakere",
  用户收益: "Brukeravkastning",
  "流动性WEB3.0输出": "Likviditet WEB3.0-output",
  总资产: "Totale eiendeler",

  ETHAI持有数据收益: "ETHAI beholdningsdataavkastning",
  AI量化流动性: "AI kvantitativ likviditet",
  现货买入手续费: "Spot kjøpsgebyr",
  现货支出: "Spot utgift",
  现货资金费率: "Spot finansieringsrente",
  现货卖出手续费: "Spot salgsgebyr",
  现货收入: "Spot inntekt",
  外汇合约支出: "Valutaterminkontrakt utgift",
  外汇合约买入手续费: "Valutaterminkontrakt kjøpsgebyr",
  外汇合约资金费率: "Valutaterminkontrakt finansieringsrente",
  外汇合约卖出手续费: "Valutaterminkontrakt salgsgebyr",
  外汇合约收入: "Valutaterminkontrakt inntekt",
  理财购买: "Formuesforvaltning kjøp",
  VIP理财日收益: "VIP formuesforvaltning daglig avkastning",
  VIP理财隔夜利息: "VIP formuesforvaltning overnattingsrente",
  VIP本金返还: "VIP tilbakebetaling av hovedstol",
  VIP彩金发放: "VIP bonus utbetaling",
  VIP彩金抵扣: "VIP bonus fratrekk",
  隔夜利息: "Overnattingsrente",
  设置资产密码: "Angi aktivapassord",

  锁仓挖矿: "Låst mining",
  一站式理财服务: "Alt-i-ett finansielle tjenester",
  产品: "Produkter",
  客服中心: "Kundesenter",
  贷款: "Lån",
  挖矿赚不停: "Tjen kontinuerlig fra mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Låst mining innebærer at USDT (USD:1USDT=1USD) settes inn i plattformens høyytelses miningmaskiner for å generere avkastning i plattformens miningpool.",
  产品优势: "Produktfordeler",
  随存随取: "Sett inn og ta ut når som helst",
  锁仓周期: "Låseperiode",
  每日下发: "Daglig utbetaling",
  随机空投: "Tilfeldig airdrop",
  "100%资金安全保障": "100% sikkerhet for midler",
  "100%节假日收益不间断": "100% kontinuerlig avkastning også på helligdager",
  成功锁仓后当天产出: "Avkastning starter samme dag etter vellykket låsing",
  关于违约金: "Om gebyr ved brudd",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Hvis du tar ut kapital før forfall, påløper et gebyr. Gebyr = bruddsats × gjenværende dager × låst beløp.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Eksempel: bruddsatsen er 5 %, det gjenstår 3 dager, og låst beløp er 10000U (USDT/USD). Gebyr = 5%×3×10000=1500U, faktisk tilbakeført kapital er 15000U-1500U.",
  收益计算: "Avkastningsberegning",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Plattformen tilbyr flere finansielle produkter for låst mining. Avkastningsberegning er som følger, for eksempel:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Hvis en bruker låser 10000U (USDT, USD) og velger et 7-dagers produkt med daglig avkastning på 0,7%~1,8% av låst beløp, er daglig avkastning som følger:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Etter 7 dager kan du få 490U~1260U i avkastning. Avkastningen utbetales daglig, og kapitalen overføres automatisk til kontoen ved forfall.",
  正在托管的资金: "Midler under forvaltning",
  签到: "Daglig innsjekk",
  锁仓订单: "Låste ordre",
  预计今日收益: "Estimert dagens avkastning",
  累计收益: "Akkumulert avkastning",
  托管中的订单: "Ordre under forvaltning",
  单笔最少: "Minimum per ordre",
  单笔最多: "Maksimum per ordre",
  日收益率: "Daglig avkastning",
  说明: "Forklaring",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistikk baseres på GMT+8 tid<br>2. Daglig avkastning beregnes fra alle avregnede ordre mellom 00:00-23:59 GMT+8 (lokal tid 00:00-23:59)<br>3. Avkastning utbetales neste dag mellom 00:00-00:10 GMT+8.",
  知道了: "Forstått",
  锁仓: "Lås",
  派息时间: "Utbetalingstid",
  每日: "Daglig",
  托管资金: "Forvaltede midler",
  到期返回: "Tilbake ved forfall",
  提前赎回: "Tidlig uttak",
  预计收益: "Estimert avkastning",
  认购: "Tegning",
  热门: "Populær",
  数字货币: "Kryptovaluta",
  贵金属: "Edelmetaller",
  大宗商品: "Råvarer",
  持仓明细: "Posisjonsdetaljer",
  历史明细: "Historikk",
  当前价: "Nåværende pris",
  "↑买涨": "↑ Kjøp oppgang",
  "↓买跌": "↓ Kjøp nedgang",
  显示全部: "Vis alle",
  买入金额: "Kjøpsbeløp",
  方向: "Retning",
  收益: "Fortjeneste",
  预期收益: "Forventet fortjeneste",
  估用保证金: "Estimert margin",
  确认下单: "Bekreft ordre",
  锁定: "Låst",
  账户总资产: "Totale kontoaktiva",
  明细: "Detaljer",
  今日收益: "Dagens avkastning",
  仓位保证金: "Posisjonsmargin",
  持有仓位: "Åpne posisjoner",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Låst beløp = summen av alle ufullførte låste mining-ordre",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistikk baseres på GMT+8 tid<br>2. Daglig avkastning beregnes fra alle avregnede ordre mellom 00:00-23:59 GMT+8",
  充值方式: "Innskuddsmetode",
  银行汇款: "Bankoverføring",
  "银行汇款请联系客服进行操作!": "Kontakt kundeservice for bankoverføring!",
  提款方式: "Uttaksmetode",
  "银行提款请联系客服进行操作!": "Kontakt kundeservice for bankuttak!",
  资金明细: "Fondsdetaljer",
  提现记录: "Uttakshistorikk",
  拒绝: "Avvist",
  通过: "Godkjent",
  拒绝原因: "Avslagsårsak",

  消息公告: "Meldinger",
  订单: "Bestillinger",
  个人中心: "Personlig senter",
  "未到期赎回需支付一定的违约金!":
    "Ved førtidig innløsning må det betales en straffegebyr.",

  请输入区号: "Vennligst skriv inn retningsnummer",
  "请选择国家/地区": "Vennligst velg land/region",

  今日开盘: "Dagens åpning",
  昨日收盘: "Gårsdagens slutt",

  实名认证即送: "Motta um leið eftir auðkennisstaðfestingu",
  立即认证: "Staðfesta núna",
  新用户礼包: "Gjafapakki fyrir nýja notendur",
  完成新人任务领取: "Ljúktu verkefnum fyrir nýja notendur til að sækja",
  认证: "Staðfesta",
  时间周期: "Tímabil",
  支付金额: "Greiðsluupphæð",
  已平仓: "Lokað",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX móttökupakki fyrir nýja notendur: Hver notandi getur að hámarki fengið",
  我已经阅读并同意: "Ég hef lesið og samþykki",
  隐私政策: "Persónuverndarstefna",

  放弃奖励离开: "Gi opp belønningen og forlat",
  继续注册: "Fortsett registreringen",
  分钟: "Minutter",

  "请先勾选隐私政策!": "Vennligst sjekk personvernerklæringen først!",
  添加其他到自选: "Legg til andre i overvåkningslisten",

  充值最高可得: "Fyll på og få opptil 30 000 dollar.",

  请输入格式正确的手机号: "Vennligst oppgi et gyldig mobilnummer.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 挪威



// WEBPACK FOOTER //
// ./src/lang/nw.js